import React,{useEffect, useState} from 'react'
import Boardcard from '../../Components/Boardcard/Boardcard'
import ButtonPagenate from '../../Components/ButtonPagenate/ButtonPagenate'
import Navbar from '../../Components/Navbar/navbar'
import Topbarsub from '../../Components/Topbar/Topbarsub'
import '../Employee/employee.css'
import './role.css'
import { useCookies } from 'react-cookie';
import { AiFillDelete} from 'react-icons/ai'
import RoleList from './roleList'

const Role = ({page, addnewoverlay, empselect}) => {
  console.log(empselect.allDesignations)
  const [cookies] = useCookies(['Token']);
  const API = 'https://'
  const [searchcriteria, setSearchcriteria] = useState("")
  const [role, setRole] = useState(empselect.allDesignations)
  const [nameSearch, setNameSearch] = useState("")
  
  const [pageNumber, setPageNumber] = useState(0);
//   const [loading, setLoading] = useState(true)
//   const [ confirmresponse, setConfirmresponse] = useState(0)

  const itemsPerpage = 5;                                       //Number of items to be displayed per page 
  const pageCount = Math.ceil(role.length / itemsPerpage);
  const pagesVisited = pageNumber * itemsPerpage;

  // const totalRoles = role.length;
  // [n, n+1, n+2, ...]
  const totalJDs = role.reduce((sum, items) => sum = sum + (items.job_description.length), 0)
  // console.log(totalJDs)

    const handleSearchCriteria = (incoming) =>{
      setSearchcriteria(incoming)
    }

    useEffect(() => {
      // 👇️ scroll to top on page load
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, []);

    const handleAddNewEmp = () =>{

    }

    const filterSearch = (incoming) =>{
      setNameSearch(incoming.toString())
    }

    var EmployeeLists = role.filter((filteredItem) => {
        if (searchcriteria === "" && nameSearch === "") {
          return filteredItem;
        } else if (searchcriteria !== "" && nameSearch === "") {
          return filteredItem;
        } else if (searchcriteria === "" && nameSearch !== "") {
          return filteredItem;
        } else if (searchcriteria !== "" && nameSearch !== "") {
          if(searchcriteria === "Fullname"){
            if (filteredItem.firstname.toLowerCase().includes(nameSearch.toLowerCase())) {
              return filteredItem;
            }
          } else if(searchcriteria === "Role"){
            if (filteredItem.role.toLowerCase().includes(nameSearch.toLowerCase())) {
              return filteredItem;
            }
          } else {
            return filteredItem;
          }
        }
    });

    const newPagenum = (num) =>{
      setPageNumber(num)
    }

    // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
    const handleDelete = async(props) =>{
      // setConfirmload(true)
      try {
        var config = {
          method: 'DELETE',
          url: `${API}/changeEmpactive/${props}`,
          data: {},
          headers: { 
            Authorization: "Bearer " + cookies.Token
          }
        };
    
      //   await axios(config).then((response) => {
      //   // console.log(response.data.data);
      //   if(response.data.success === true){
      //     // do something
      //   }else{
      //     // do something
      //   }});
      } catch(e){
        if(e.message.includes('401')){
          // catch error
        } else{
          // catch error
        }
      }
    }

    // const handleEdit = (incoming) =>{
    //   addnewoverlay(incoming)
    //   console.log(incoming)
    //     // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
    // }

    const handleaddOverlay = (incoming) =>{
      addnewoverlay(incoming)
    }

    useEffect(() => {
      handleWidth()
    }, [])
  
    const [widthval, setWidthval] = useState({
      pie1: 0,
      pie2: 0
    })
  
    const handleWidth = () =>{
      setWidthval({pie1: role.length, pie2: totalJDs})
    }

  return (
    <div className='employee-container'>
        <Navbar tabtext="Job Roles" currentab='others'/>
        <Topbarsub serchCriteria={handleSearchCriteria} newEmployee={handleAddNewEmp} currrenTab={page} searchword={filterSearch} addoverlay={handleaddOverlay}/>
        <div className='tretapp-card-container'>
          <Boardcard val={widthval.pie1} name="Total Role" maxV={15} minV={0}/>
          <Boardcard val={widthval.pie2} name="Job Description" maxV={100} minV={0}/>
        </div>

        <div className='tretapp-list-submitted'>
            <div className='tapp-list-title-container'>
              <span id='tapp-list-title'>Role List</span>
            </div>
            <div className='comp-list-table-containerr'>
                <table>
                    <thead>
                        <tr>
                            <th scope="col">#ID</th>
                            <th scope="col">Role</th>
                            <th scope="col">Job Description</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {EmployeeLists.slice(pagesVisited, pagesVisited + itemsPerpage).map((items) =>(
                            <tr>
                                <td data-label="#ID">{items.ID}</td>
                                <td data-label="Role">{items.job_role}</td>
                                <td data-label="JD" id='cell-container'>{(items.job_description).map((item)=>(
                                  <li>{item}</li>
                                ))}</td>
                                <td data-label="Action"><AiFillDelete onClick={() => handleDelete(items.id)} id='butn-action'/></td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className='papp-table-pgnate-contain'>
                  <button id='addbitn' onClick={() => handleaddOverlay({tag: 'newrole'})}>Add</button>
                    <ButtonPagenate 
                    updatedPageNum={newPagenum}
                    pageCount={pageCount}
                    pageNumber={pageNumber}
                    previousLabel="Prev"
                    nextLabel="Next"/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Role